import { Injectable, inject } from '@angular/core';
import {environment} from '../../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {QtdSessoes} from '../model/homeBuscas/qtd-sessoes.model';
import {QtdOperadores} from '../model/homeBuscas/qtd-operadores.model';
import {QtdAtendimentos} from '../model/homeBuscas/qtd-atendimentos.model';
import {RankingOperador} from '../model/homeBuscas/ranking-operador.model';

@Injectable({
  providedIn: 'root'
})
export class HomeBuscasService {
  private readonly http = inject(HttpClient);

  urlBase = `${environment.urlBase}/home-buscas`;

  buscarQtdSessoes(): Observable<QtdSessoes> {
    return this.http.get<QtdSessoes>(`${this.urlBase}/qtds-sessoes`);
  }
  buscarQtdOperadores(): Observable<QtdOperadores> {
    return this.http.get<QtdOperadores>(`${this.urlBase}/qtds-operadores`);
  }
  buscarQtdAtendimentos(): Observable<QtdAtendimentos> {
    return this.http.get<QtdAtendimentos>(`${this.urlBase}/qtds-atendimentos`);
  }
  buscarResumoHome(): Observable<QtdAtendimentos> {
    return this.http.get<QtdAtendimentos>(`${this.urlBase}/resumo-home`, { headers: { 'no-loading': 'true' } });
  }
  buscarRankingOperador(): Observable<RankingOperador[]> {
    return this.http.get<RankingOperador[]>(`${this.urlBase}/ranking-operador`);
  }
}
